import { Base } from './base';

export default class ShareServiceList extends Base {
	constructor () {
		super()
	}

	async listData( id ) {
		const res = await this.shares_list( id )
		const { list } = res.posts

		return list
	}

	async videoListData( id ) {
		const res = await this.shares_video_list( id )
		const { list } = res.posts

		return list
	}
}
